// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"dBB1J47E"};